import { render, staticRenderFns } from "./PlaylistItemsPanel.vue?vue&type=template&id=403dddb0&scoped=true"
import script from "./PlaylistItemsPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlaylistItemsPanel.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PlaylistItemsPanel.vue?vue&type=style&index=0&id=403dddb0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403dddb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('403dddb0')) {
      api.createRecord('403dddb0', component.options)
    } else {
      api.reload('403dddb0', component.options)
    }
    module.hot.accept("./PlaylistItemsPanel.vue?vue&type=template&id=403dddb0&scoped=true", function () {
      api.rerender('403dddb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layoutDesigner/editor/settingPanel/playlist/PlaylistItemsPanel.vue"
export default component.exports